import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';
import {
  type AccessRight,
  ROLE_OPTIONS_MAP,
} from 'lumen/utils/constants/users-constants';

import styles from './cell-role.module.css';

interface SettingsUsersTablesCellsCellRoleSignature {
  Args: {
    cellData: AccessRight;
    row: {
      isDisabled?: boolean;
      onRoleChange?: (role: AccessRight) => void;
      originalRole?: AccessRight;
    };
  };
}

export default class CellRole extends Component<SettingsUsersTablesCellsCellRoleSignature> {
  @service declare intl: Services['intl'];

  get displayRole(): AccessRight {
    if (this.args.row.isDisabled && this.args.row.originalRole) {
      return this.args.row.originalRole;
    }

    return this.args.cellData;
  }

  get options(): Option[] {
    return Object.entries(ROLE_OPTIONS_MAP).map(([key, translationKey]) => ({
      key,
      label: this.intl.t(translationKey),
    }));
  }

  get selectedOption(): Option | undefined {
    return this.options.find((option) => option.key === this.displayRole);
  }

  @action
  handleChange(option: Option | null | undefined): void {
    if (option) {
      this.args.row.onRoleChange?.(option.key as AccessRight);
    }
  }

  <template>
    <div class={{styles.container}}>
      <PrismSelectInput
        @disabled={{@row.isDisabled}}
        @isSmall={{true}}
        @onChange={{this.handleChange}}
        @options={{this.options}}
        @unsafe_matchTriggerWidth={{true}}
        @value={{this.selectedOption}}
        data-test-id="cell-role-select"
      />
    </div>
  </template>
}
